import React, { useContext } from 'react';
import { Step as StepperStep, StepLabel, Stepper as MuiStepper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UIContext } from '../../context/UIContext';
import { Step } from '../../types';

const Stepper = ({ currentStepIndex, steps }: { currentStepIndex: number; steps: Step[] }) => {
  const { t } = useTranslation();
  const { isSmallDevice, noStepsDevice } = useContext(UIContext);

  return (
    !noStepsDevice &&
    steps &&
    Array.isArray(steps) &&
    steps?.length > 0 && (
      <MuiStepper
        nonLinear
        alternativeLabel={isSmallDevice}
        activeStep={currentStepIndex}
        sx={{
          justifyContent: 'space-between',
          marginTop: { xs: 0, md: 1 },
          marginBottom: { xs: 4, md: 5 },
        }}
      >
        {steps.map((step, index) => (
          <StepperStep
            key={`step-${step.stepKey}`}
            completed={step.completedAt != null}
            sx={{
              ...(index === 0 && {
                paddingLeft: `${
                  !(currentStepIndex === steps.length - 1) && !step.startedAt ? 0 : '8px'
                }`,
                paddingRight: `${
                  !(currentStepIndex === steps.length - 1) && step.startedAt ? 0 : '8px'
                }`,
              }),

              ...(index === steps.length - 1 && {
                paddingLeft: `${
                  !(currentStepIndex === steps.length - 1) && step.startedAt ? 0 : '8px'
                }`,
                paddingRight: `${
                  !(currentStepIndex === steps.length - 1) && !step.startedAt ? 0 : '8px'
                }`,
              }),

              ':not(.Mui-completed) svg': {
                color: `${currentStepIndex === index ? 'primary.main' : 'text.secondary'}`,
              },
              ':not(.Mui-completed) span': {
                color: 'text.secondary',
              },
            }}
          >
            <StepLabel>{t(`steps.${step.stepKey}.title`)}</StepLabel>
          </StepperStep>
        ))}
      </MuiStepper>
    )
  );
};

export default Stepper;
